export const EGYPT_DISTRICTS = [
  { value: 'DIST-00308', label: 'إدكو', governorate: 'البحيرة' },
  { value: 'DIST-00307', label: 'مدينة طيبة', governorate: 'الأقصر' },
  { value: 'DIST-00306', label: 'حي المنتزه ثالث', governorate: 'الإسكندرية' },
  { value: 'DIST-00305', label: 'دمياط الجديدة', governorate: 'دمياط' },
  { value: 'DIST-00304', label: 'جسر السويس', governorate: 'القاهرة' },
  { value: 'DIST-00303', label: 'فيصل', governorate: 'الجيزة' },
  { value: 'DIST-00302', label: 'مدينة الشروق', governorate: 'القاهرة' },
  { value: 'DIST-00301', label: 'القطامية', governorate: 'القاهرة' },
  { value: 'DIST-00300', label: 'مدينتي', governorate: 'القاهرة' },
  { value: 'DIST-00299', label: 'الرحاب', governorate: 'القاهرة' },
  { value: 'DIST-00298', label: 'القاهرة الجديدة', governorate: 'القاهرة' },
  { value: 'DIST-00297', label: 'المطرية', governorate: 'القاهرة' },
  { value: 'DIST-00296', label: 'طرة', governorate: 'القاهرة' },
  { value: 'DIST-00295', label: 'مصر القديمة', governorate: 'القاهرة' },
  { value: 'DIST-00294', label: 'الدرب الأحمر', governorate: 'القاهرة' },
  { value: 'DIST-00293', label: 'الجمالية', governorate: 'القاهرة' },
  { value: 'DIST-00292', label: 'الأزبكية', governorate: 'القاهرة' },
  { value: 'DIST-00291', label: 'حدائق أكتوبر', governorate: 'الجيزة' },
  { value: 'DIST-00290', label: 'مدينة الجيزة', governorate: 'الجيزة' },
  { value: 'DIST-00289', label: 'الحوامدية', governorate: 'الجيزة' },
  { value: 'DIST-00288', label: 'الشيخ زايد', governorate: 'الجيزة' },
  { value: 'DIST-00287', label: 'العجوزة', governorate: 'الجيزة' },
  { value: 'DIST-00286', label: 'بولاق الدكرور', governorate: 'الجيزة' },
  { value: 'DIST-00285', label: 'الوراق', governorate: 'الجيزة' },
  { value: 'DIST-00284', label: 'إمبابة', governorate: 'الجيزة' },
  { value: 'DIST-00283', label: 'الصالحية الجديدة', governorate: 'الشرقية' },
  { value: 'DIST-00282', label: 'صان الحجر', governorate: 'الشرقية' },
  { value: 'DIST-00281', label: 'الحسينية', governorate: 'الشرقية' },
  { value: 'DIST-00280', label: 'جمصة', governorate: 'الدقهلية' },
  { value: 'DIST-00279', label: 'ميت سلسيل', governorate: 'الدقهلية' },
  { value: 'DIST-00278', label: 'إدكو', governorate: 'البحيرة' },
  { value: 'DIST-00277', label: 'أبو رماد', governorate: 'البحر الأحمر' },
  { value: 'DIST-00276', label: 'الداير', governorate: 'البحر الأحمر' },
  { value: 'DIST-00275', label: 'حلايب', governorate: 'البحر الأحمر' },
  { value: 'DIST-00274', label: 'شلاتين', governorate: 'البحر الأحمر' },
  { value: 'DIST-00273', label: 'مرسى علم', governorate: 'البحر الأحمر' },
  { value: 'DIST-00272', label: 'القصاصين', governorate: 'الإسماعيلية' },
  { value: 'DIST-00271', label: 'التل الكبير', governorate: 'الإسماعيلية' },
  { value: 'DIST-00270', label: 'أبو صوير', governorate: 'الإسماعيلية' },
  { value: 'DIST-00269', label: 'القنطرة غرب', governorate: 'الإسماعيلية' },
  { value: 'DIST-00268', label: 'برج العرب', governorate: 'الإسكندرية' },
  { value: 'DIST-00267', label: 'أبو زنيمة', governorate: 'جنوب سيناء' },
  { value: 'DIST-00266', label: 'أبو رديس', governorate: 'جنوب سيناء' },
  { value: 'DIST-00265', label: 'رأس سدر', governorate: 'جنوب سيناء' },
  { value: 'DIST-00264', label: 'سانت كاترين', governorate: 'جنوب سيناء' },
  { value: 'DIST-00263', label: 'طابا', governorate: 'جنوب سيناء' },
  { value: 'DIST-00262', label: 'دهب', governorate: 'جنوب سيناء' },
  { value: 'DIST-00261', label: 'البرلس', governorate: 'كفر الشيخ' },
  { value: 'DIST-00260', label: 'سيدي براني', governorate: 'مطروح' },
  { value: 'DIST-00259', label: 'العلمين', governorate: 'مطروح' },
  { value: 'DIST-00258', label: 'الحمام', governorate: 'مطروح' },
  { value: 'DIST-00257', label: 'العسيرات', governorate: 'سوهاج' },
  { value: 'DIST-00256', label: 'توشكى الجديدة', governorate: 'أسوان' },
  { value: 'DIST-00255', label: 'أبو سمبل', governorate: 'أسوان' },
  { value: 'DIST-00254', label: 'إسنا', governorate: 'الأقصر' },
  { value: 'DIST-00253', label: 'الطود', governorate: 'الأقصر' },
  { value: 'DIST-00252', label: 'الخصوص', governorate: 'القليوبية' },
  { value: 'DIST-00251', label: 'قها', governorate: 'القليوبية' },
  { value: 'DIST-00250', label: 'العبور', governorate: 'القليوبية' },
  { value: 'DIST-00249', label: 'شبرا الخيمة', governorate: 'القليوبية' },
  { value: 'DIST-00248', label: 'بور فؤاد', governorate: 'بورسعيد' },
  { value: 'DIST-00247', label: 'الدقي', governorate: 'الجيزة' },
  { value: 'DIST-00246', label: 'السادس من أكتوبر', governorate: 'الجيزة' },
  { value: 'DIST-00245', label: 'العمرانية', governorate: 'الجيزة' },
  { value: 'وسط البلد', label: 'وسط البلد', governorate: 'القاهرة' },
  { value: 'القنايات', label: 'القنايات', governorate: 'الشرقية' },
  { value: 'بدر١', label: 'بدر', governorate: 'القاهرة' },
  {
    value: 'حي الشرق الأوسط الصناعي (المنطقة الحرة)',
    label: 'حي الشرق الأوسط الصناعي (المنطقة الحرة)',
    governorate: 'بورسعيد',
  },
  { value: 'حي الجنوب', label: 'حي الجنوب', governorate: 'بورسعيد' },
  { value: 'حي الزهور', label: 'حي الزهور', governorate: 'بورسعيد' },
  { value: 'حي الضواحي', label: 'حي الضواحي', governorate: 'بورسعيد' },
  { value: 'حي المناخ', label: 'حي المناخ', governorate: 'بورسعيد' },
  { value: 'حي العرب', label: 'حي العرب', governorate: 'بورسعيد' },
  { value: 'حي الغرب', label: 'حي الغرب', governorate: 'بورسعيد' },
  { value: 'حي الشرق', label: 'حي الشرق', governorate: 'بورسعيد' },
  { value: 'حي غرب', label: 'حي غرب', governorate: 'الإسكندرية' },
  { value: 'حي الجمرك', label: 'حي الجمرك', governorate: 'الإسكندرية' },
  {
    value: 'حي العامرية ثان',
    label: 'حي العامرية ثان',
    governorate: 'الإسكندرية',
  },
  {
    value: 'حي العامرية أول',
    label: 'حي العامرية أول',
    governorate: 'الإسكندرية',
  },
  { value: 'حي العجمي', label: 'حي العجمي', governorate: 'الإسكندرية' },
  { value: 'حي وسط', label: 'حي وسط', governorate: 'الإسكندرية' },
  { value: 'حي شرق', label: 'حي شرق', governorate: 'الإسكندرية' },
  {
    value: 'حي المنتزه ثان',
    label: 'حي المنتزه ثان',
    governorate: 'الإسكندرية',
  },
  {
    value: 'حي المنتزه أول',
    label: 'حي المنتزه أول',
    governorate: 'الإسكندرية',
  },
  { value: 'دار السلام', label: 'دار السلام', governorate: 'القاهرة' },
  { value: 'حدائق القبة', label: 'حدائق القبة', governorate: 'القاهرة' },
  { value: 'الزيتون', label: 'الزيتون', governorate: 'القاهرة' },
  { value: 'المقطم القديم', label: 'المقطم القديم', governorate: 'القاهرة' },
  { value: 'الخليفة', label: 'الخليفة', governorate: 'القاهرة' },
  { value: 'السيدة زينب', label: 'السيدة زينب', governorate: 'القاهرة' },
  { value: 'قصر النيل', label: 'قصر النيل', governorate: 'القاهرة' },
  { value: 'عابدين', label: 'عابدين', governorate: 'القاهرة' },
  { value: 'الموسكي', label: 'الموسكي', governorate: 'القاهرة' },
  { value: 'منشأة ناصر', label: 'منشأة ناصر', governorate: 'القاهرة' },
  { value: 'الوايلي', label: 'الوايلي', governorate: 'القاهرة' },
  { value: 'الظاهر', label: 'الظاهر', governorate: 'القاهرة' },
  { value: 'باب الشعرية', label: 'باب الشعرية', governorate: 'القاهرة' },
  { value: 'الأزبكية', label: 'الأزبكية', governorate: 'القاهرة' },
  { value: 'بولاق', label: 'بولاق', governorate: 'القاهرة' },
  { value: 'المعصرة', label: 'المعصرة', governorate: 'القاهرة' },
  { value: '15 مايو', label: '15 مايو', governorate: 'القاهرة' },
  { value: 'التبين', label: 'التبين', governorate: 'القاهرة' },
  { value: 'حلوان', label: 'حلوان', governorate: 'القاهرة' },
  { value: 'المقطم', label: 'المقطم', governorate: 'القاهرة' },
  { value: 'البساتين', label: 'البساتين', governorate: 'القاهرة' },
  { value: 'المعادى', label: 'المعادى', governorate: 'القاهرة' },
  { value: 'مدينة نصر ثان', label: 'مدينة نصر ثان', governorate: 'القاهرة' },
  { value: 'مدينة نصر أول', label: 'مدينة نصر أول', governorate: 'القاهرة' },
  { value: 'مصر الجديدة', label: 'مصر الجديدة', governorate: 'القاهرة' },
  { value: 'النزهة', label: 'النزهة', governorate: 'القاهرة' },
  { value: 'النهضة', label: 'النهضة', governorate: 'القاهرة' },
  { value: 'المرج', label: 'المرج', governorate: 'القاهرة' },
  { value: 'السلام ثان', label: 'السلام ثان', governorate: 'القاهرة' },
  { value: 'السلام أول', label: 'السلام أول', governorate: 'القاهرة' },
  { value: 'عين شمس', label: 'عين شمس', governorate: 'القاهرة' },
  { value: 'شبرا', label: 'شبرا مصر', governorate: 'القاهرة' },
  { value: 'الساحل', label: 'الساحل', governorate: 'القاهرة' },
  { value: 'الشرابية', label: 'الشرابية', governorate: 'القاهرة' },
  {
    value: 'الزاوية الحمراء',
    label: 'الزاوية الحمراء',
    governorate: 'القاهرة',
  },
  { value: 'ركابية', label: 'ركابية', governorate: 'دمياط' },
  { value: 'قويسنا', label: 'قويسنا', governorate: 'المنوفية' },
  { value: 'كفر البطيخ', label: 'كفر البطيخ', governorate: 'دمياط' },
  { value: 'الزرقا', label: 'الزرقا', governorate: 'دمياط' },
  { value: 'السلوم', label: 'السلوم', governorate: 'مطروح' },
  { value: 'السويس', label: 'السويس', governorate: 'السويس' },
  { value: 'القصير', label: 'القصير', governorate: 'البحر الأحمر' },
  { value: 'سفاجا', label: 'سفاجا', governorate: 'البحر الأحمر' },
  { value: 'رأس غارب', label: 'رأس غارب', governorate: 'البحر الأحمر' },
  { value: 'الغردقة', label: 'الغردقة', governorate: 'البحر الأحمر' },
  { value: 'نويبع', label: 'نويبع', governorate: 'جنوب سيناء' },
  { value: 'شرم الشيخ', label: 'شرم الشيخ', governorate: 'جنوب سيناء' },
  { value: 'الطور', label: 'الطور', governorate: 'جنوب سيناء' },
  { value: 'نخل', label: 'نخل', governorate: 'شمال سيناء' },
  { value: 'بئر العبد', label: 'بئر العبد', governorate: 'شمال سيناء' },
  { value: 'الحسنة', label: 'الحسنة', governorate: 'شمال سيناء' },
  { value: 'الشيخ زويد', label: 'الشيخ زويد', governorate: 'شمال سيناء' },
  { value: 'رفح', label: 'رفح', governorate: 'شمال سيناء' },
  { value: 'العريش', label: 'العريش', governorate: 'شمال سيناء' },
  { value: 'الدلنجات 2', label: 'الدلنجات 2', governorate: 'البحيرة' },
  { value: 'سيوة', label: 'سيوة', governorate: 'مطروح' },
  { value: 'النجيلة', label: 'النجيلة', governorate: 'مطروح' },
  { value: 'الضبعة', label: 'الضبعة', governorate: 'مطروح' },
  { value: 'مرسى مطروح', label: 'مرسى مطروح', governorate: 'مطروح' },
  { value: 'كفر سعد', label: 'كفر سعد', governorate: 'دمياط' },
  { value: 'فارسكور', label: 'فارسكور', governorate: 'دمياط' },
  { value: 'دمياط', label: 'دمياط', governorate: 'دمياط' },
  { value: 'القنطرة شرق', label: 'القنطرة شرق', governorate: 'الإسماعيلية' },
  { value: 'فايد', label: 'فايد', governorate: 'الإسماعيلية' },
  { value: 'الإسماعيلية', label: 'الإسماعيلية', governorate: 'الإسماعيلية' },
  { value: 'بلاط', label: 'بلاط', governorate: 'الوادي الجديد' },
  { value: 'باريس', label: 'باريس', governorate: 'الوادي الجديد' },
  { value: 'الفرافرة', label: 'الفرافرة', governorate: 'الوادي الجديد' },
  { value: 'الداخلة', label: 'الداخلة', governorate: 'الوادي الجديد' },
  { value: 'الخارجة', label: 'الخارجة', governorate: 'الوادي الجديد' },
  { value: 'أبشواي', label: 'أبشواي', governorate: 'الفيوم' },
  { value: 'يوسف الصديق', label: 'يوسف الصديق', governorate: 'الفيوم' },
  { value: 'طامية', label: 'طامية', governorate: 'الفيوم' },
  { value: 'سنورس', label: 'سنورس', governorate: 'الفيوم' },
  { value: 'إطسا', label: 'إطسا', governorate: 'الفيوم' },
  { value: 'الفيوم', label: 'الفيوم', governorate: 'الفيوم' },
  { value: 'إدفو', label: 'إدفو', governorate: 'أسوان' },
  { value: 'نصر النوبة', label: 'نصر النوبة', governorate: 'أسوان' },
  { value: 'دراو', label: 'دراو', governorate: 'أسوان' },
  { value: 'كوم أمبو', label: 'كوم أمبو', governorate: 'أسوان' },
  { value: 'أسوان', label: 'أسوان', governorate: 'أسوان' },
  { value: 'أرمنت', label: 'أرمنت', governorate: 'الأقصر' },
  { value: 'القرنة', label: 'القرنة', governorate: 'الأقصر' },
  { value: 'البياضية', label: 'البياضية', governorate: 'الأقصر' },
  { value: 'الزينية', label: 'الزينية', governorate: 'الأقصر' },
  { value: 'الأقصر', label: ' مدينة الأقصر', governorate: 'الأقصر' },
  { value: 'الوقف', label: 'الوقف', governorate: 'قنا' },
  { value: 'أبوتشت', label: 'أبوتشت', governorate: 'قنا' },
  { value: 'فرشوط', label: 'فرشوط', governorate: 'قنا' },
  { value: 'نقادة', label: 'نقادة', governorate: 'قنا' },
  { value: 'دشنا', label: 'دشنا', governorate: 'قنا' },
  { value: 'قوص', label: 'قوص', governorate: 'قنا' },
  { value: 'قفط', label: 'قفط', governorate: 'قنا' },
  { value: 'نجع حمادي', label: 'نجع حمادي', governorate: 'قنا' },
  { value: 'قنا', label: 'قنا', governorate: 'قنا' },
  { value: 'طهطا', label: 'طهطا', governorate: 'سوهاج' },
  { value: 'جهينة', label: 'جهينة', governorate: 'سوهاج' },
  { value: 'ساقلتة', label: 'ساقلتة', governorate: 'سوهاج' },
  { value: 'المنشأة', label: 'المنشأة', governorate: 'سوهاج' },
  { value: 'البلينا', label: 'البلينا', governorate: 'سوهاج' },
  { value: 'دار السلام١', label: 'دار السلام', governorate: 'سوهاج' },
  { value: 'أخميم', label: 'أخميم', governorate: 'سوهاج' },
  { value: 'المراغة', label: 'المراغة', governorate: 'سوهاج' },
  { value: 'طما', label: 'طما', governorate: 'سوهاج' },
  { value: 'جرجا', label: 'جرجا', governorate: 'سوهاج' },
  { value: 'سوهاج', label: 'سوهاج', governorate: 'سوهاج' },
  { value: 'القوصية', label: 'القوصية', governorate: 'أسيوط' },
  { value: 'صدفا', label: 'صدفا', governorate: 'أسيوط' },
  { value: 'أبنوب', label: 'أبنوب', governorate: 'أسيوط' },
  { value: 'الفتح', label: 'الفتح', governorate: 'أسيوط' },
  { value: 'ساحل سليم', label: 'ساحل سليم', governorate: 'أسيوط' },
  { value: 'الغنايم', label: 'الغنايم', governorate: 'أسيوط' },
  { value: 'البداري', label: 'البداري', governorate: 'أسيوط' },
  { value: 'أبو تيج', label: 'أبو تيج', governorate: 'أسيوط' },
  { value: 'منفلوط', label: 'منفلوط', governorate: 'أسيوط' },
  { value: 'ديروط', label: 'ديروط', governorate: 'أسيوط' },
  { value: 'أسيوط', label: 'أسيوط', governorate: 'أسيوط' },
  { value: 'سمالوط', label: 'سمالوط', governorate: 'المنيا' },
  { value: 'دير مواس', label: 'دير مواس', governorate: 'المنيا' },
  { value: 'مغاغة', label: 'مغاغة', governorate: 'المنيا' },
  { value: 'العدوة', label: 'العدوة', governorate: 'المنيا' },
  { value: 'أبو قرقاص', label: 'أبو قرقاص', governorate: 'المنيا' },
  { value: 'ملوي', label: 'ملوي', governorate: 'المنيا' },
  { value: 'بني مزار', label: 'بني مزار', governorate: 'المنيا' },
  { value: 'مطاي', label: 'مطاي', governorate: 'المنيا' },
  { value: 'المنيا', label: 'المنيا', governorate: 'المنيا' },
  { value: 'الفشن', label: 'الفشن', governorate: 'بني سويف' },
  { value: 'سمسطا', label: 'سمسطا', governorate: 'بني سويف' },
  { value: 'ببا', label: 'ببا', governorate: 'بني سويف' },
  { value: 'اهناسيا', label: 'اهناسيا', governorate: 'بني سويف' },
  { value: 'ناصر', label: 'ناصر', governorate: 'بني سويف' },
  { value: 'الواسطى', label: 'الواسطى', governorate: 'بني سويف' },
  { value: 'بني سويف', label: 'بني سويف', governorate: 'بني سويف' },
  { value: 'قطور', label: 'قطور', governorate: 'الغربية' },
  { value: 'المحلة الكبرى', label: 'المحلة الكبرى', governorate: 'الغربية' },
  { value: 'سمنود', label: 'سمنود', governorate: 'الغربية' },
  { value: 'السنطة', label: 'السنطة', governorate: 'الغربية' },
  { value: 'زفتى', label: 'زفتى', governorate: 'الغربية' },
  { value: 'بسيون', label: 'بسيون', governorate: 'الغربية' },
  { value: 'كفر الزيات', label: 'كفر الزيات', governorate: 'الغربية' },
  { value: 'طنطا', label: 'طنطا', governorate: 'الغربية' },
  { value: 'الباجور', label: 'الباجور', governorate: 'المنوفية' },
  { value: 'بركة السبع', label: 'بركة السبع', governorate: 'المنوفية' },
  { value: 'الشهداء', label: 'الشهداء', governorate: 'المنوفية' },
  { value: 'تلا', label: 'تلا', governorate: 'المنوفية' },
  { value: 'أشمون', label: 'أشمون', governorate: 'المنوفية' },
  { value: 'السادات', label: 'السادات', governorate: 'المنوفية' },
  { value: 'سرس الليان', label: 'سرس الليان', governorate: 'المنوفية' },
  { value: 'منوف', label: 'منوف', governorate: 'المنوفية' },
  { value: 'شبين الكوم', label: 'شبين الكوم', governorate: 'المنوفية' },
  { value: 'مطوبس', label: 'مطوبس', governorate: 'كفر الشيخ' },
  { value: 'فوه', label: 'فوه', governorate: 'كفر الشيخ' },
  { value: 'دسوق', label: 'دسوق', governorate: 'كفر الشيخ' },
  { value: 'الرياض', label: 'الرياض', governorate: 'كفر الشيخ' },
  { value: 'بلطيم', label: 'بلطيم', governorate: 'كفر الشيخ' },
  { value: 'الحامول', label: 'الحامول', governorate: 'كفر الشيخ' },
  { value: 'بيلا', label: 'بيلا', governorate: 'كفر الشيخ' },
  { value: 'قلين', label: 'قلين', governorate: 'كفر الشيخ' },
  { value: 'سيدي سالم', label: 'سيدي سالم', governorate: 'كفر الشيخ' },
  { value: 'كفر الشيخ', label: 'كفر الشيخ', governorate: 'كفر الشيخ' },
  { value: 'أبو المطامير', label: 'أبو المطامير', governorate: 'البحيرة' },
  { value: 'بدر', label: 'بدر ', governorate: 'البحيرة' },
  { value: 'وادي النطرون', label: 'وادي النطرون', governorate: 'البحيرة' },
  {
    value: 'النوبارية الجديدة',
    label: 'النوبارية الجديدة',
    governorate: 'البحيرة',
  },
  { value: 'حوش عيسى', label: 'حوش عيسى', governorate: 'البحيرة' },
  { value: 'كوم حمادة', label: 'كوم حمادة', governorate: 'البحيرة' },
  { value: 'رشيد', label: 'رشيد', governorate: 'البحيرة' },
  { value: 'المحمودية', label: 'المحمودية', governorate: 'البحيرة' },
  { value: 'الرحمانية', label: 'الرحمانية', governorate: 'البحيرة' },
  { value: 'شبراخيت', label: 'شبراخيت', governorate: 'البحيرة' },
  { value: 'إيتاي البارود', label: 'إيتاي البارود', governorate: 'البحيرة' },
  { value: 'الدلنجات', label: 'الدلنجات', governorate: 'البحيرة' },
  { value: 'أبو حمص', label: 'أبو حمص', governorate: 'البحيرة' },
  { value: 'كفر الدوار', label: 'كفر الدوار', governorate: 'البحيرة' },
  { value: 'دمنهور', label: 'دمنهور', governorate: 'البحيرة' },
  {
    value: 'منشأة عبد الرحمن',
    label: 'منشأة عبد الرحمن',
    governorate: 'الدقهلية',
  },
  { value: 'محلة دمنة', label: 'محلة دمنة', governorate: 'الدقهلية' },
  { value: 'المنزلة', label: 'المنزلة', governorate: 'الدقهلية' },
  { value: 'شربين', label: 'شربين', governorate: 'الدقهلية' },
  { value: 'الكردي', label: 'الكردي', governorate: 'الدقهلية' },
  { value: 'الجمالية', label: 'الجمالية', governorate: 'الدقهلية' },
  { value: 'المطرية', label: 'المطرية', governorate: 'الدقهلية' },
  { value: 'تمي الأمديد', label: 'تمي الأمديد', governorate: 'الدقهلية' },
  { value: 'السنبلاوين', label: 'السنبلاوين', governorate: 'الدقهلية' },
  { value: 'بلقاس', label: 'بلقاس', governorate: 'الدقهلية' },
  { value: 'نبروه', label: 'نبروه', governorate: 'الدقهلية' },
  { value: 'بني عبيد', label: 'بني عبيد', governorate: 'الدقهلية' },
  { value: 'منية النصر', label: 'منية النصر', governorate: 'الدقهلية' },
  { value: 'أجا', label: 'أجا', governorate: 'الدقهلية' },
  { value: 'دكرنس', label: 'دكرنس', governorate: 'الدقهلية' },
  { value: 'ميت غمر', label: 'ميت غمر', governorate: 'الدقهلية' },
  { value: 'طلخا', label: 'طلخا', governorate: 'الدقهلية' },
  { value: 'المنصورة', label: 'المنصورة', governorate: 'الدقهلية' },
  { value: 'القرين', label: 'القرين', governorate: 'الشرقية' },
  { value: 'مشتول السوق', label: 'مشتول السوق', governorate: 'الشرقية' },
  { value: 'ديرب نجم', label: 'ديرب نجم', governorate: 'الشرقية' },
  { value: 'أولاد صقر', label: 'أولاد صقر', governorate: 'الشرقية' },
  { value: 'كفر صقر', label: 'كفر صقر', governorate: 'الشرقية' },
  { value: 'فاقوس', label: 'فاقوس', governorate: 'الشرقية' },
  { value: 'الإبراهيمية', label: 'الإبراهيمية', governorate: 'الشرقية' },
  { value: 'ههيا', label: 'ههيا', governorate: 'الشرقية' },
  { value: 'أبو كبير', label: 'أبو كبير', governorate: 'الشرقية' },
  { value: 'منيا القمح', label: 'منيا القمح', governorate: 'الشرقية' },
  { value: 'أبو حماد', label: 'أبو حماد', governorate: 'الشرقية' },
  {
    value: 'العاشر من رمضان',
    label: 'العاشر من رمضان',
    governorate: 'الشرقية',
  },
  { value: 'بلبيس', label: 'بلبيس', governorate: 'الشرقية' },
  { value: 'الزقازيق', label: 'الزقازيق', governorate: 'الشرقية' },
  { value: 'كفر شكر', label: 'كفر شكر', governorate: 'القليوبية' },
  { value: 'قليوب', label: 'قليوب', governorate: 'القليوبية' },
  {
    value: 'القناطر الخيرية',
    label: 'القناطر الخيرية',
    governorate: 'القليوبية',
  },
  { value: 'الخانكة', label: 'الخانكة', governorate: 'القليوبية' },
  { value: 'شبين القناطر', label: 'شبين القناطر', governorate: 'القليوبية' },
  { value: 'طوخ', label: 'طوخ', governorate: 'القليوبية' },
  { value: 'بنها', label: 'بنها', governorate: 'القليوبية' },
  { value: 'الهرم', label: 'الهرم', governorate: 'الجيزة' },
  { value: 'الواحات البحرية', label: 'الواحات البحرية', governorate: 'الجيزة' },
  { value: 'أبو النمرس', label: 'أبو النمرس', governorate: 'الجيزة' },
  { value: 'كرداسة', label: 'كرداسة', governorate: 'الجيزة' },
  { value: 'منشأة القناطر', label: 'منشأة القناطر', governorate: 'الجيزة' },
  { value: 'أوسيم', label: 'أوسيم', governorate: 'الجيزة' },
  { value: 'العياط', label: 'العياط', governorate: 'الجيزة' },
  { value: 'أطفيح', label: 'أطفيح', governorate: 'الجيزة' },
  { value: 'الصف', label: 'الصف', governorate: 'الجيزة' },
  { value: 'البدرشين', label: 'البدرشين', governorate: 'الجيزة' },
];
